import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class ActiveRecordingOption extends Component {
    static propTypes = {
        isRecording: PropTypes.bool,
    };
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <ul style={{ float: 'left', marginRight: '10px' }} className="fileAdding-disabled">
                {this.props.isRecording ? (
                    <li>
                        <p
                            className="flex items-center px-1 py-1.5 rounded-full text-white"
                            style={{ backgroundColor: '#C01B1B69' }}
                        >
                            <svg
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12.47 22C17.9928 22 22.47 17.5228 22.47 12C22.47 6.47715 17.9928 2 12.47 2C6.94712 2 2.46997 6.47715 2.46997 12C2.46997 17.5228 6.94712 22 12.47 22Z"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M12.5 16.23C14.8362 16.23 16.73 14.3362 16.73 12C16.73 9.66386 14.8362 7.77002 12.5 7.77002C10.1639 7.77002 8.27002 9.66386 8.27002 12C8.27002 14.3362 10.1639 16.23 12.5 16.23Z"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span className="ml-2">{this.props.t('recordingOn')}</span>
                        </p>
                    </li>
                ) : (
                    ''
                )}
            </ul>
        );
    }
}

const ConnectedActiveRecordingOption = withLanguage(connect()(ActiveRecordingOption));

export default (props) => (
    <LanguageProvider>
        <ConnectedActiveRecordingOption {...props} />
    </LanguageProvider>
);
